import { useEffect, useState } from 'react'
import { Mode } from '../../models/enums'

const useMode = (instanceId?: string): Mode => {
  const [current, setCurrent] = useState<Mode>(Mode.text)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_mode', ((e: CustomEvent) => handleChange(e)) as EventListener)
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_mode'))

    return () => {
      document.removeEventListener('retorik_mode', ((e: CustomEvent) => handleChange(e)) as EventListener)
    }
  }, [])

  return current
}

export default useMode
